module.exports = __webpack_public_path__ + "media/pro/Amazon-39adb799.png";